interface Props {
  activeColor: string;
}

const AllLeadsIcon = ({ activeColor }: Props) => {
  const fillColor = activeColor === "#0f1560" ? "#EA580C" : "#0f1560";

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="30" fill="#e3e9fc" />

      <circle cx="24" cy="26" r="5" stroke="#2F4BFF" strokeWidth="3" />

      <path
        d="M14 42c0-5 4-9 10-9s10 4 10 9"
        stroke="#2F4BFF"
        strokeWidth="3"
        strokeLinecap="round"
      />

      <circle cx="40" cy="26" r="5" stroke="#2F4BFF" strokeWidth="3" />

      <path
        d="M30 42c0-5 4-9 10-9s10 4 10 9"
        stroke="#2F4BFF"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AllLeadsIcon;
